module.exports = __webpack_public_path__ + "static/media/logo.795e5675.svg";